'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;
function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments[1];

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }
  return obj;
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/validator/lib/util/merge.js
 ** module id = 209
 ** module chunks = 0
 **/